module.exports = __webpack_public_path__ + "static/media/Rubik-Light.90a01309.ttf";